import React from 'react';

/**
 * Attempts to open the OneTrust cookie preferences panel.
 * Prevents default link behaviour if event is provided.
 */
export const handleCookieClick = (event?: React.MouseEvent<HTMLAnchorElement>): void => {
  try {
    event?.preventDefault();
    window?.OneTrust?.ToggleInfoDisplay?.();
  } catch (error) {
    console.error('OneTrust.ToggleInfoDisplay() failed:', error);
  }
};

/**
 * Generate a random, Base-36, fixed 10-character string (eg: "hdjl39jkf1").
 */
export const generateRandomId = (): string => {
  return Math.random().toString(36).slice(2, 12).padEnd(10, '0');
};